<div class="wrapper drop-padding">
  <app-folder-selector [control]="folderControl"></app-folder-selector>
  <button mat-flat-button (click)="add()" color="primary">Добавить</button>
</div>
